import { useState } from 'react';
import LieuxTab from '../components/referentiel/LieuxTab';
import ManifestationsTab from '../components/referentiel/ManifestationsTab';
import SeancesTab from '../components/referentiel/SeancesTab';
import { PageHeader, SegmentedControl, type SegmentedOption } from '../components/ui';

type TabId = 'lieux' | 'manifestations' | 'seances';

const TABS: readonly SegmentedOption<TabId>[] = [
  { value: 'lieux', label: 'Lieux' },
  { value: 'manifestations', label: 'Manifestations' },
  { value: 'seances', label: 'Séances' },
];

export default function Referentiel() {
  const [tab, setTab] = useState<TabId>('lieux');

  return (
    <div className="space-y-5">
      <PageHeader title="Référentiel" />

      <SegmentedControl label="Sections du référentiel" options={TABS} value={tab} onChange={setTab} />

      {tab === 'lieux' ? <LieuxTab /> : null}
      {tab === 'manifestations' ? <ManifestationsTab /> : null}
      {tab === 'seances' ? <SeancesTab /> : null}
    </div>
  );
}
